/**
 * @generated SignedSource<<a0b7d66ce0b19c8050ef5240d2697991>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClipTrimmerSaveClipMutation$variables = {
  endTime: number;
  recordingId: string;
  startTime: number;
  title?: string | null;
};
export type ClipTrimmerSaveClipMutation$data = {
  readonly createClip: {
    readonly clip: {
      readonly clipEnd: number;
      readonly clipStart: number;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_ClipSummary_clip">;
    };
    readonly meetingRecording: {
      readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_meetingRecording">;
    };
  } | null;
};
export type ClipTrimmerSaveClipMutation = {
  response: ClipTrimmerSaveClipMutation$data;
  variables: ClipTrimmerSaveClipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTime"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recordingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = [
  {
    "kind": "Variable",
    "name": "endTime",
    "variableName": "endTime"
  },
  {
    "kind": "Variable",
    "name": "recordingId",
    "variableName": "recordingId"
  },
  {
    "kind": "Variable",
    "name": "startTime",
    "variableName": "startTime"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clipStart",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clipEnd",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoDuration",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v11 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClipTrimmerSaveClipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreateClip",
        "kind": "LinkedField",
        "name": "createClip",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecordingClip",
            "kind": "LinkedField",
            "name": "clip",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ClipsPanel_ClipSummary_clip"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ClipsPanel_meetingRecording"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ClipTrimmerSaveClipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreateClip",
        "kind": "LinkedField",
        "name": "createClip",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecordingClip",
            "kind": "LinkedField",
            "name": "clip",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingClip",
                "kind": "LinkedField",
                "name": "clips",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanEdit",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoPosterUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoUrl",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFavourite",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "lastEditedBy",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "type": "MeetingRecordingInterface",
                    "abstractKey": "__isMeetingRecordingInterface"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20ba96b43115145a0e30b8277018fb6a",
    "id": null,
    "metadata": {},
    "name": "ClipTrimmerSaveClipMutation",
    "operationKind": "mutation",
    "text": "mutation ClipTrimmerSaveClipMutation(\n  $recordingId: ID!\n  $startTime: Float!\n  $endTime: Float!\n  $title: String\n) {\n  createClip(recordingId: $recordingId, startTime: $startTime, endTime: $endTime, title: $title) {\n    clip {\n      id\n      clipStart\n      clipEnd\n      ...ClipsPanel_ClipSummary_clip\n    }\n    meetingRecording {\n      ...ClipsPanel_meetingRecording\n      id\n    }\n  }\n}\n\nfragment ClipsPanel_ClipCard_clip on MeetingRecordingClip {\n  id\n  title\n  viewerCanEdit\n  meetingRecordedVideoDuration\n  meetingRecordedVideoPosterUrl\n  meetingRecordedVideoUrl\n  summary\n  isFavourite\n  creator {\n    id\n    fullName\n  }\n  lastEditedBy {\n    id\n    fullName\n  }\n  ...utils_useGetURL_recording\n  ...ClipsPanel_RenameClipModal_clip\n  ...ClipsPanel_DeleteClipModal_clip\n}\n\nfragment ClipsPanel_ClipSummary_clip on MeetingRecordingClip {\n  id\n  title\n  meetingRecordedVideoDuration\n  summary\n}\n\nfragment ClipsPanel_DeleteClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_RenameClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_meetingRecording on MeetingRecording {\n  id\n  clips {\n    id\n    ...ClipsPanel_ClipCard_clip\n  }\n}\n\nfragment utils_useGetURL_recording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  ... on MeetingRecording {\n    id\n  }\n  ... on MeetingRecordingClip {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b28a7b5f77c7052f648f93fe6676bcd";

export default node;
